import React from "react";
import { Datagrid, ListContextProvider, TextField, useListContext } from "react-admin";
import { CustomDateField } from "../../../Components/CustomDateField";
import { PbhRequestStatus } from "../../../Enums/PbhRequestStatus";
import CustomLinearProgress from "../../../Components/Progress/LinearProgress";
import RefNoField from "../../../Components/ReferenceFields/RefNoField/RefNoField";
import CopyableTableWrapper from "../../../Components/CopyableTableWrapper";
import DataGridActionsButtons from "../../RequestOrder/Components/PbhRequestOrderList/DataGrid/DataGridActionsButtons";
import WarehousePanel from "../../RequestOrder/Components/PbhRequestOrderList/DataGrid/WarehousePanel";
import { makeStyles } from "@material-ui/core";
import RequirementCategory from "../../../Enums/RequirementCategory";
import { useAuth } from "@airborne/react-admin";

const useStyles = makeStyles({
  datagrid: {
    "& .MuiTableCell-root": {
      padding: "0px !important",
      marginLeft: "0px !important",
      marginRight: "0px !important",
    },
    "& .MuiTableCell-head": {
      padding: "0px 2px 0px 2px !important",
    },
    "& .MuiTableCell-body": {
      padding: "0px",
      color: "unset !important",
    },
    "& .MuiTableCell-sizeSmall": {
      padding: "0px 2px 0px 2px !important",
    },
  },
});

export const CmsDataGrid = props => {
  const classes = useStyles();
  const listContext = useListContext();
  const { user } = useAuth();
  const { isXSmall, onCreateRemarks, activeTab, ...rest } = props;
  const { ids, loading } = listContext;

  const onEdit = (id, basePath, record) => {
    if (basePath == "/pbhrequestremarks/pbhrequestorders/") {
      onCreateRemarks?.(record);
    } else {
      const win: any = window.open(`#/pbhrequestorders/${id}`, "_blank");
      win.focus();
    }
  };

  const rowStyle = (record, index) => {
    if (record.requirementCategoryText === RequirementCategory.AOG) {
      return { color: "red" };
    }
    return { color: "black" };
  };

  return (
    <>
      {isXSmall ? (
        <ListContextProvider {...rest} value={{ ...listContext, ids: ids }}>
          <></>
        </ListContextProvider>
      ) : (
        <ListContextProvider
          {...rest}
          value={{
            ...listContext,
            ids: ids,
          }}
        >
          <CustomLinearProgress loading={loading} periodTime={500} />
          {!loading && (
            <CopyableTableWrapper>
              <Datagrid
                optimized
                {...props}
                rowStyle={rowStyle}
                classes={{ table: classes.datagrid }}
                hasBulkActions={false}
                expand={!user?.isCustomer && <WarehousePanel />}
              >
                <DataGridActionsButtons label={"Actions"} onEdit={onEdit} tabValue={PbhRequestStatus.ShippingProcess} />
                <RefNoField label="REF NO" />
                <TextField source="customerName" label="CUSTOMER" />
                <TextField source="customerPo" label="CUSTOMER PO" />
                <TextField source="requirementCategoryText" label="REQUIREMENT CATEGORY" />
                <TextField source="pn" label="PN" />
                <TextField source="pnDescription" label="PN DESCRIPTION" />
                <TextField source="airportCode" label="DESTINATION" />
                <TextField source="acRegistration" label="AC" />
                <CustomDateField source="createdDate" label="REQUEST DATE" showTime />
                <CustomDateField
                  source="requestedDeliveryDate"
                  label="REQUESTED DELIVERY DATE"
                  showTime
                  locales="en-GB"
                />
                <TextField source="requestStatusText" label="STATUS" />
                {!user?.isCustomer && <TextField source="currentPbhNote" label="PBH NOTE" />}
              </Datagrid>
            </CopyableTableWrapper>
          )}
        </ListContextProvider>
      )}
    </>
  );
};

export default CmsDataGrid;
